import axios from 'axios';
import {
  BuyTicketRequest,
  BuyTicketResponse,
  TicketTransaction,
  TicketPurchase,
} from '../types/ticket';
import { API_ENDPOINTS } from '../config/api';

const api = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

export const ticketApi = {
  // Kullanıcının fiş bakiyesini getir
  async getUserBalance(userId: number): Promise<number> {
    try {
      const response = await api.get(API_ENDPOINTS.ticketsBalance(userId));
      return response.data.balance;
    } catch (error) {
      console.error('Bakiye sorgulama hatası:', error);
      throw new Error('Bakiye bilgisi alınamadı');
    }
  },

  // Fiş satın al
  async purchaseTickets(
    userId: number,
    purchaseData: BuyTicketRequest
  ): Promise<BuyTicketResponse> {
    try {
      const response = await api.post(API_ENDPOINTS.ticketsPurchase, {
        userId,
        ...purchaseData,
      });
      return response.data;
    } catch (error: any) {
      console.error('Fiş satın alma hatası:', error);
      const errorMessage = error.response?.data?.error || 'Fiş satın alma işlemi başarısız';
      throw new Error(errorMessage);
    }
  },

  // Fiş kullan (sipariş verirken)
  async useTickets(
    userId: number,
    quantity: number,
    orderId?: number,
    description?: string
  ): Promise<{ success: boolean; new_balance: number }> {
    try {
      const response = await api.post(API_ENDPOINTS.ticketsUse, {
        user_id: userId,
        quantity,
        order_id: orderId,
        description,
      });
      return response.data;
    } catch (error: any) {
      console.error('Fiş kullanma hatası:', error);
      const errorMessage = error.response?.data?.error || 'Fiş kullanma işlemi başarısız';
      throw new Error(errorMessage);
    }
  },

  // Kullanıcının işlem geçmişini getir
  async getTransactionHistory(userId: number, limit: number = 50): Promise<TicketTransaction[]> {
    try {
      const response = await api.get(`${API_ENDPOINTS.ticketsTransactions(userId)}?limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('İşlem geçmişi getirme hatası:', error);
      throw new Error('İşlem geçmişi alınamadı');
    }
  },

  // Kullanıcının satın alma geçmişini getir
  async getPurchaseHistory(userId: number, limit: number = 50): Promise<TicketPurchase[]> {
    try {
      const response = await api.get(`${API_ENDPOINTS.ticketsPurchases(userId)}?limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Satın alma geçmişi getirme hatası:', error);
      throw new Error('Satın alma geçmişi alınamadı');
    }
  },

  // Admin: Tüm fiş işlemlerini getir
  async getAllTransactions(limit: number = 100): Promise<TicketTransaction[]> {
    try {
      const response = await api.get(`${API_ENDPOINTS.ticketsAdminTransactions}?limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Tüm işlemleri getirme hatası:', error);
      throw new Error('İşlem listesi alınamadı');
    }
  },
};
